import { useState, useEffect } from "react";

import { NavLink } from "react-router-dom";

import { ReactComponent as RatingSvg } from '../assets/rating.svg';
import { ReactComponent as StarSvg } from '../assets/star.svg';
import { ReactComponent as ShowSvg } from '../assets/show.svg';
import { ReactComponent as EditSvg } from '../assets/edit.svg';

import { smartDateFormatTimestamp, formatDate } from "../utils/functions";
import { db } from "../firebase";
import { collection, query, orderBy, where, getDocs } from "firebase/firestore";

export default function ProjectList({projects, order, orderDirection, range=false, status='all', loading=false}) {

	//console.log('projects');
	//console.log(projects);

    const [projectList, setProjectList] = useState(false);

	const site = process.env.REACT_APP_DEMO_SITE;

	const testOnDevice = (projectId) => {
        window.open(site + '' + projectId + '/', '_blank');
    }

	const sort = (projects) => {

		let data = [].concat(projects).sort((a, b) => {
			if (order == 'users'){
				if (a['analytics'] && a['analytics']['users'])
					a = a['analytics']['users'].length;
				if (b['analytics'] && b['analytics']['users'])
					b = b['analytics']['users'].length;
			} else {
				a = a[order];
				b = b[order];
			}

			return b - a;
		});

		if (orderDirection == 'asc')
			data.reverse();

		return data;
	}

	const getByStatus = (projects, status) => {

		if (status == 'all')
			return projects
		else

		var data=[];
		for (let key in projects){
			let project = projects[key];
			if (project['status'] == status){
				data.push(project);
			}
		}
		return data;
	}

	const getRange = (projects, range) => {

		var data=[];
		for (let key in projects){
			let project = projects[key];
			let date = false;
			if (project['last_activity'])
				date = new Date(project['last_activity'].seconds * 1000);

			switch(range){
				case 'Last 24 Hours':
					var date_from = new Date();
					date_from.setDate(date_from.getDate() - 1);
					break;

				case 'Last Week':
					var date_from = new Date();
					date_from.setDate(date_from.getDate() - 7);
					break;

				case 'Last Month':
					var date_from = new Date();
					date_from.setDate(date_from.getDate() - 30);
					break;
			}

			if (!date_from || (date > date_from))
				data.push(project);

		}

		return data;
	}

    useEffect(() => {

		if (projects.length > 0) {
			let data = getRange(projects, range);
			data = getByStatus(data, status);
			data = sort(data);

			console.log(data);
			setProjectList(data);

		} else {

			setProjectList([]);

		}

    }, [projects, range, order, orderDirection, status]);

    return (

		<>

			{!!projectList &&

				(projectList.length == 0 ?

					(loading ?
						<div className="not-found">
							loading
						</div>
						:
						<div className="not-found">
							No results
						</div>
					)

					:
					<div className="list">
						{projectList.map((project, index) =>
							<div className={
								'project' +
								(project['userFoundInSearch'] ? ' project-with-user' : '')
							} key={index}>
								<div className="left">
									<div className=
									{
										{
											'publish':      "status status_green",
											'draft':        "status status_grey",
											'disapproved':  "status status_red"
										}[project.status]
									}
									>
									</div>
									<NavLink className="title" to={"/project/"+project.id}>
										{/*
											{formatDate(project.creation_date)} -
										*/}

										{project.name}
										{project['userFoundInSearch'] &&

											<div className="user">
												(User: {project['userFoundInSearch'].firstName + ' ' + project['userFoundInSearch'].lastName})
											</div>

										}
									</NavLink>
									<div className="users">
										{project['analytics'] && project['analytics']['users'] && project['analytics']['users'].length}
									</div>
									<div className="date">
										{project['analytics'] && project['analytics']['last_activity'] && smartDateFormatTimestamp(project['analytics']['last_activity'].seconds)}
									</div>
									{/*
									<div className="time">
										{project.time}min
									</div>
									*/}
								</div>
								<div className="icons">
									<NavLink className="title" to={"/project/"+project.id+"#performance"}>
										<div data-tooltip="App performance">
											<RatingSvg />
										</div>
									</NavLink>
									{/*
										<div data-tooltip="App actions"><StarSvg /></div>
									*/}
									<div data-tooltip="Test on device" onClick={() => testOnDevice(project.id)}><ShowSvg /></div>
									<NavLink to={"/edit/"+project.id}>
										<div data-tooltip="Edit">
											<EditSvg />
										</div>
									</NavLink>
								</div>
							</div>
						)}
					</div>
				)
			}
		</>
	)
}
